import React from 'react'


export default class Title extends React.Component{

    render()
    {
        const {title,color}=this.props
        const context=this.props.context
        const {org,config}=context

        var Title=((props)=><h2 {...props} />)
        if(context.isMobile){
            Title=((props)=><h2 {...props} />)
        }

        if(!color)
        {
            return (
                <div style={{position:"relative",height:200,width:"100%",marginTop: context.isMobile ? 90 : 130,boxShadow:"rgba(0, 0, 0, 0.16) 0px 1px 4px"}}>

                    <div style={{height:"inherit",width:"inherit",position:"relative",zIndex:100,display:"flex",justifyContent:context.isMobile?"center":"flex-start",alignItems:"center",padding:context.isMobile?"0 5%":" 0 100px"}}>
                        <Title style={{color:"#000",fontFamily:"Heebo",textShadow:"0.5px 1px 4px #FFF"}}>{title}</Title>
                    </div>

                </div>
            )
        }

        return (
            <div style={{position:"relative",height:200,width:"100%",marginTop: context.isMobile ? 90 : 130,boxShadow:"rgba(0, 0, 0, 0.16) 0px 1px 4px"}}>
                <div style={{height:"inherit",width:"inherit",position:"absolute",zIndex:10,backgroundColor:color+"9F"}}/>

                <div style={{height:"inherit",width:"inherit",position:"relative",zIndex:100,display:"flex",justifyContent:context.isMobile?"center":"flex-start",alignItems:"center",padding:context.isMobile?"0 5%":" 0 100px"}}>
                    <Title style={{color:"#FFF",fontFamily:"Heebo",textShadow:"0.5px 1px 4px black"}}>{title}</Title>
                </div>

            </div>
        )
    }

}

